<body id="bootstrap-overrides">
  <h1>Platform System Tests Application</h1>

  <div id="error_panel" *ngIf="errorMessage" style="color: red">
    <div class="card mb-3">
      <div class="card-body">
        <h2>An unexpected error occurred.</h2>
        <p id="error_message">
          {{errorMessage}}
        </p>
      </div>
    </div>
  </div>

  <div id="token_information_panel" *ngIf="signedInDisplay">
    <div class="card mb-3">
      <div class="card-body">
        <p>
          <span><b>Last populated state returned: </b></span><span id="response_additional_state">{{ additionalState }}</span>
        </p>
        <p>
          <span><b>Access token expiration: </b></span><span id="access_token_expiration">{{ accessTokenExpiry }}</span>
        </p>
      </div>
    </div>
  </div>

  <div id="raw_tokens_panel" *ngIf="signedInDisplay">
    <div class="card mb-3">
      <div class="card-body">
        <p><b>access_token: </b></p><p id="raw_access_token">{{ accessToken }}</p>
        <p><b>refresh_token: </b></p><p id="raw_refresh_token">{{ refreshToken }}</p>
      </div>
    </div>
  </div>

  <div id="further_actions_panel" *ngIf="signedInDisplay">
    <div class="card mb-3">
      <div class="card-body">
        <h2>Further Actions</h2>
        <div class="d-grid gap-2 d-md-block">
          <button id="refresh_tokens_btn" class="btn btn-primary" (click)="refresh()" type="button">Refresh Tokens</button>
        </div>
      </div>
    </div>
  </div>
</body>